import { client } from '../../../../../common-utils/libraries/axios/axios';
import { buildUrl } from '@/common-utils/functions/restUtils';
import { AUTOCOMPLETE } from '../apiUrls';

/**
 * @param root0
 * @param root0.features
 * @returns Mapped data object
 */
function mapResponseData({ features }) {
    const data = features.map((element) => element.properties.name).sort();

    return data;
}

const queryGetAddress = (city, cityCode, postCode, address, enabled) => {
    const query = { city: city, q: address, citycode: cityCode, postcode: postCode, type: 'street', limit: 10 };

    return {
        queryKey: [AUTOCOMPLETE.DETAILS.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(AUTOCOMPLETE.DETAILS.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetAddress;